import type { ChangeEvent } from 'react'
import { AuthLayout } from '@/modules/auth/ui/components'
import { formatTryAgainLabel } from '@/shared/ui/hooks'
import { Button, Input } from '@/shared/ui/primitives'

export type AccountLinkStateProps = {
  inviteEmail: string
  linkEmail: string
  isSubmitting: boolean
  cooldownSeconds: number
  onLinkEmailChange: (value: string) => void
  onSendCode: () => void
  onCancel: () => void
}

export function AccountLinkState({
  inviteEmail,
  linkEmail,
  isSubmitting,
  cooldownSeconds,
  onLinkEmailChange,
  onSendCode,
  onCancel,
}: AccountLinkStateProps) {
  const subtitle = inviteEmail
    ? `This invitation was sent to ${inviteEmail}. Enter the email on your existing BlindBook account and we'll link this invitation to it.`
    : `Enter the email on your existing BlindBook account and we'll link this invitation to it.`

  return (
    <AuthLayout title="Sign in to your account" subtitle={subtitle}>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <label htmlFor="account-link-email" className="text-sm text-fg-dim">
            Email on your existing account
          </label>
          <Input
            id="account-link-email"
            type="email"
            autoComplete="email"
            placeholder="you@example.com"
            value={linkEmail}
            onChange={(e: ChangeEvent<HTMLInputElement>) => onLinkEmailChange(e.target.value)}
            disabled={isSubmitting}
          />
        </div>

        <Button
          type="button"
          variant="default"
          onClick={onSendCode}
          disabled={isSubmitting || cooldownSeconds > 0 || linkEmail.trim().length === 0}
        >
          {cooldownSeconds > 0 ? formatTryAgainLabel(cooldownSeconds) : 'Send me a sign-in code'}
        </Button>

        <Button type="button" variant="outline" onClick={onCancel} disabled={isSubmitting}>
          Cancel
        </Button>
      </div>
    </AuthLayout>
  )
}
